import { PublicKey, type PublicKeyWire } from "./public-key.js";

export type NodeId = PublicKey;
export const NodeId = PublicKey;
export type NodeIdWire = PublicKeyWire;
